@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.footer {
  padding: 10px;
  height: auto;
  min-height: 70px;
  line-height: normal;
  text-align: left;

  &.processing {
    background-color: @label-batch-status--footer-processing--background-color;
  }
  &.complete {
    background-color: @label-batch-status--footer-complete--background-color;
  }
  &.complete-errored {
    background-color: @label-batch-status--footer-complete-errored--background-color;
  }
  .footer-text {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .footer-details {
    font-size: 13px;
    color: @label-batch-status--footer-details--text-color;
  }
}
